(function () {
  let loading = false;

  const money = (cents) =>
    (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'INR',
    });

  function updateArrows() {
    const wrap = document.getElementById('cart-drawer-recs');
    if (!wrap) return;
    const list = wrap.querySelector('.cart-recs__list');
    const nav = wrap.querySelector('.cart-recs__nav');
    const [prev, next] = wrap.querySelectorAll('.cart-recs__arrow');
    const overflow = list.scrollWidth > list.clientWidth + 2;
    nav.style.visibility = overflow ? 'visible' : 'hidden';
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
  }

  async function loadCartRecs() {
    const wrap = document.getElementById('cart-drawer-recs');
    if (!wrap || loading) return;
    const list = wrap.querySelector('.cart-recs__list');
    if (list.children.length) return;

    loading = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      if (!cart.items.length) return;

      const last = cart.items[0];
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(
        `${root}recommendations/products.json?product_id=${last.product_id}&limit=10&intent=related`
      );
      const { products } = await res.json();

      const inCart = cart.items.map((i) => i.product_id);
      const recs = products
        .filter((p) => p.available && !inCart.includes(p.id))
        .slice(0, 8);
      if (!recs.length) return;

      list.innerHTML = recs
        .map((p) => {
          const single = p.variants.length === 1;
          const alt = p.title.replace(/"/g, '&quot;');
          return `
          <div class="cart-recs__item">
            <div class="cart-recs__top">
              <a href="${p.url}" class="cart-recs__img">
                <img src="${p.featured_image}" alt="${alt}" width="70" height="70" loading="lazy">
              </a>
              <div class="cart-recs__info">
                <a href="${p.url}" class="cart-recs__name">${p.title}</a>
                <span class="cart-recs__price">${money(p.price)}</span>
              </div>
            </div>
            ${
              single
                ? `<button type="button" class="cart-recs__add" data-variant="${p.variants[0].id}">Quick Add</button>`
                : `<a href="${p.url}" class="cart-recs__add">Quick Add</a>`
            }
          </div>`;
        })
        .join('');
      wrap.hidden = false;
      requestAnimationFrame(updateArrows);
    } catch (e) {
      console.error('Cart recs error', e);
    } finally {
      loading = false;
    }
  }

  document.addEventListener('click', async (e) => {
    // Slider arrows
    const arrow = e.target.closest('.cart-recs__arrow');
    if (arrow) {
      const list = document.querySelector('#cart-drawer-recs .cart-recs__list');
      const item = list.querySelector('.cart-recs__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      list.scrollBy({
        left: Number(arrow.dataset.dir) * (item.offsetWidth + gap),
        behavior: 'smooth',
      });
      return;
    }

    // Quick Add
    const btn = e.target.closest('button.cart-recs__add');
    if (!btn) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: Number(btn.dataset.variant),
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections) drawer.renderContents(data);
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Quick Add';
    }
  });

  // scroll event bubble nahi hota, isliye capture use kiya
  document.addEventListener(
    'scroll',
    (e) => {
      if (e.target.classList && e.target.classList.contains('cart-recs__list')) updateArrows();
    },
    true
  );
  window.addEventListener('resize', updateArrows);

  function observeDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(() => loadCartRecs()).observe(drawer, {
      childList: true,
      subtree: true,
    });
    loadCartRecs();
  }

  document.addEventListener('DOMContentLoaded', observeDrawer);
})();